// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/snake/Snake.css */

.snake-container {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 96vw;
  min-height: 0;               /* важно для вложенных flex */
  max-width: 400px;
  height: calc(100% - 20px);
  max-height: 900px;

  /* Фон теперь почти черный, матрица будет canvas-слоем */
  background-color: #050505;

  border: 4px solid #333;
  border-radius: 16px;
  box-shadow:
    0 0 0 1px #000,
    inset 0 0 40px rgba(0, 0, 0, 0.8),
    0 20px 60px rgba(0,0,0,0.9);

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  box-sizing: border-box;
  font-family: 'Courier New', monospace;
  color: #00ff41;
  z-index: 6000;
  -webkit-user-select: none;
          user-select: none;

    /* Блокируем стандартные жесты браузера (скролл, зум) */
    touch-action: none;
    overflow: hidden;
}

/* ЗАГОЛОВОК */
.snake-header {
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 12px;
  background: #161b22;
  border: 1px solid #30363d;
  border-radius: 6px;
  box-shadow: 0 4px 0 rgba(0,0,0,0.2);
  box-sizing: border-box;
}

.snake-stat-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.snake-label {
  font-size: 10px;
  color: #8b949e;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.snake-value {
  font-size: 18px;
  font-weight: 900;
  color: #f0f6fc;
}

.snake-value.score { color: #fbbf24; text-shadow: 0 0 5px rgba(251, 191, 36, 0.3); }

/* ИГРОВОЕ ПОЛЕ */
.snake-grid {
  /* Фон стал немного прозрачнее (0.4), чтобы матрицу было видно лучше,
     но достаточно темным, чтобы был контраст */
  background: rgba(0, 0, 0, 0.4);
  border: 2px solid #30363d;
  border-radius: 4px;
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  display: grid;
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 1);
  overflow: hidden;
}

/* ЯЧЕЙКИ */
.sn-cell {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px; /* Размер буквы */

  /* ДОБАВИТЬ ЭТИ СТРОКИ: */
  line-height: 1;    /* Убирает лишние отступы шрифта */
  overflow: hidden;  /* Обрезает контент, не давая ему влиять на размер сетки */
}

/* ЗМЕЯ (ТЕЛО) */
.sn-snake-body {
  background-color: #238636; /* Вернули насыщенный зеленый */
  box-shadow: 0 0 4px #2ea043; /* Мягкое свечение */

  /* Текст: полупрозрачный и с размытой тенью для эффекта "внутри геля" */
  color: rgba(255, 255, 255, 0.5);
  text-shadow: 0 0 4px rgba(255, 255, 255, 0.4);

  border-radius: 2px;
  border: none; /* Убрали обводку */
  z-index: 2;
  /* ИСПРАВЛЕНИЕ 1: Убрали общий transition, чтобы не мелькало при появлении */
}

/* ЗМЕЯ (ГОЛОВА) */
.sn-snake-head {
  background-color: #3fb950;
  box-shadow: 0 0 12px #3fb950;
  color: #fff;
  z-index: 3;
  border-radius: 2px;
  border: none; /* Убрали обводку */
  /* ИСПРАВЛЕНИЕ 1: Убрали общий transition */
}

/* --- ЭФФЕКТ УСКОРЕНИЯ (BOOST) --- */
.sn-snake-body.boosting {
  background-color: #3fcd50 !important;
  box-shadow: 0 0 6px #45e948, 0 0 10px rgba(255, 255, 255, 0.5) !important;
  z-index: 4;
  /* НОВОЕ: Едва заметная вибрация */
  animation: sn-boost-glitch 0.1s infinite;
}

.sn-snake-head.boosting {
  background-color: #ebeb7f !important;
  box-shadow: 0 0 10px #fbff90, 0 0 10px rgba(255, 255, 255, 0.8) !important;
  z-index: 5;
  /* НОВОЕ: Едва заметная вибрация */
  animation: sn-boost-glitch 0.1s infinite;
}

/* --- СТИЛИ СМЕРТИ --- */

/* Вся змея становится красной */
.sn-snake-body.dead, .sn-snake-head.dead {
  background-color: #dc2626 !important; /* Яркий красный */
  box-shadow: 0 0 10px #ef4444 !important;
  color: #fff !important;
  border: 1px solid #7f1d1d;

  /* НОВОЕ: Анимация глитча смерти будет задаваться через JS
     или CSS класс, но базовые переходы убираем для резкости */
  transition: none;
}

/* Тряска сетки при смерти */
.snake-grid.shaking {
  animation: sn-shake-hard 0.5s cubic-bezier(.36,.07,.19,.97) both infinite;
}

@keyframes sn-shake-hard {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

/* ЕДА (КВАДРАТНАЯ) */
.sn-food {
  background-color: #da3633; /* Матовый красный */
  box-shadow: 0 0 10px #da3633; /* Красное свечение */
  color: #fff;
  font-size: 12px;
  border-radius: 2px;
  animation: sn-pulse-square 0.8s infinite alternate;
  z-index: 2;
  border: none; /* Убрали белую рамку */
}

@keyframes sn-pulse-square {
  from { transform: scale(0.85); box-shadow: 0 0 5px rgba(220, 38, 38, 0.5); }
  to { transform: scale(1.0); box-shadow: 0 0 15px rgba(220, 38, 38, 1); }
}

@keyframes sn-pulse {
  from { transform: scale(0.8); opacity: 0.8; }
  to { transform: scale(1.0); opacity: 1; }
}

/* ОВЕРЛЕЙ ПАУЗЫ */
.snake-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(13, 17, 23, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  backdrop-filter: blur(2px);
}

.snake-paused-text {
  font-size: 24px;
  font-weight: 900;
  color: #fff;
  border: 2px solid #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  transform: rotate(-3deg);
  background: rgba(0,0,0,0.5);
  box-shadow: 0 0 15px rgba(255,255,255,0.2);
}

/* --- УПРАВЛЕНИЕ (ОБНОВЛЕНО: ЛОГИКА ПОЗИЦИОНИРОВАНИЯ) --- */
.snake-controls-wrapper {
  width: 100%;
  flex-shrink: 0;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 50px 50px;
  gap: 8px;
  max-width: 300px; /* Центрирование */

  /* ЛОГИКА "ПРИЖАТЬ К НИЗУ": */
  margin-top: auto;    /* Толкает блок в самый низ свободной зоны */
  margin-bottom: 20px; /* Фиксированный отступ от дна (когда места много) */
  padding-bottom: 0;
}

/* ЛОГИКА "ЦЕНТРИРОВАТЬ, КОГДА ТЕСНО":
   Если высота экрана меньше 700px (например, старые айфоны или ландшафт),
   мы возвращаем margin-bottom: auto.
   В сочетании с margin-top: auto это центрирует блок в свободном пространстве.
*/
@media (max-height: 650px) {
  .snake-controls-wrapper {
    margin-bottom: auto;
  }
}

/* Общий стиль для всех кнопок (включая паузу) */
.sn-btn, .sn-pause-btn {
  /* Стиль тетриса: градиент, границы, тень */
  background: linear-gradient(to bottom, #34495e, #2c3e50);
  border: 1px solid #1a252f;
  border-top: 1px solid #4e6075;
  border-radius: 6px;
  color: #ecf0f1;
  font-size: 18px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; box-shadow: 0 3px 0 #151f28;
  -webkit-user-select: none;
          user-select: none; touch-action: manipulation;
}

.sn-pause-btn {
  margin: 0 0 15px 15px;
}

.sn-btn:active, .sn-pause-btn:active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 #151f28;
  background: #2c3e50;
}

/* Раскладка кнопок */
/* Верхний ряд */
.sn-up    { grid-column: 2; grid-row: 1; }
.sn-pause { grid-column: 3; grid-row: 1; } /* Справа сверху */

/* Нижний ряд */
.sn-left  { grid-column: 1; grid-row: 2; }
.sn-down  { grid-column: 2; grid-row: 2; }
.sn-right { grid-column: 3; grid-row: 2; }

/* Зеленая кнопка при паузе */
.sn-pause-btn.paused {
  background: linear-gradient(to bottom, #27ae60, #1e8449);
  border-color: #1e8449;
  box-shadow: 0 3px 0 #145a32;
  color: #fff;
}
.sn-pause-btn.paused:active {
  box-shadow: 0 1px 0 #145a32;
}

/* --- СТАРТОВЫЙ ЭКРАН (ТЕРМИНАЛ) --- */
.sn-start-card {
  width: 100%;
  max-width: 340px;
  background: rgba(5, 10, 5, 0.95);
  border: 1px solid #00ff41;
  padding: 30px 20px;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0, 255, 65, 0.2);
  text-align: center;
  position: relative;
  overflow: hidden;
}

/* Линия сканирования */
.sn-start-card::after {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; height: 5px;
  background: rgba(0, 255, 65, 0.3);
  opacity: 0.5;
  animation: sn-scanline 3s linear infinite;
}

@keyframes sn-scanline {
  0% { transform: translateY(-100%); }
  100% { transform: translateY(500px); }
}

.sn-start-icon {
  font-size: 60px;
  color: #00ff41;
  margin-bottom: 20px;
  filter: drop-shadow(0 0 10px rgba(0, 255, 65, 0.5));
  animation: sn-glitch 2s infinite;
}

@keyframes sn-glitch {
  0%, 100% { transform: skew(0deg); opacity: 1; }
  10% { transform: skew(-5deg); opacity: 0.8; }
  20% { transform: skew(5deg); opacity: 1; }
  80% { transform: none; }
}

.sn-start-title {
  font-family: 'Courier New', monospace;
  font-size: 20px;
  font-weight: 900;
  color: #00ff41;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 15px;
  border-bottom: 1px solid #333;
  padding-bottom: 10px;
}

.sn-start-desc {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  color: #a3b3a3;
  line-height: 1.5;
  margin-bottom: 30px;
  white-space: pre-line; /* Чтобы работали \\n */
}

.sn-start-btn {
  background: #00ff41;
  color: #000;
  font-family: 'Courier New', monospace;
  font-weight: 900;
  font-size: 18px;
  border: none;
  padding: 15px 0;
  width: 100%;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 0 10px rgba(0, 255, 65, 0.4);
  transition: all 0.2s;
  animation: sn-pulse-btn 1.5s infinite;
}

@keyframes sn-pulse-btn {
  0% { box-shadow: 0 0 10px rgba(0, 255, 65, 0.4); }
  50% { box-shadow: 0 0 25px rgba(0, 255, 65, 0.8); }
  100% { box-shadow: 0 0 10px rgba(0, 255, 65, 0.4); }
}

.sn-start-btn:active {
  background: #fff;
  transform: scale(0.98);
}

/* --- АНИМАЦИЯ ГЛИТЧА ПРИ ПОЕДАНИИ --- */
@keyframes sn-eat-glitch {
  0% {
    filter: brightness(1);
    transform: skew(0deg) scale(1);
  }
  20% {
    /* Вспышка белым */
    background-color: #fff;
    box-shadow: 0 0 15px #fff, 0 0 30px #0f0;
    /* Искажение */
    transform: skew(-20deg) scale(1.1) translateX(-2px);
    z-index: 10;
  }
  40% {
    /* Инверсия или затемнение на мгновение */
    background-color: #000;
    box-shadow: none;
    transform: skew(20deg) scale(0.9) translateX(2px);
  }
  60% {
    /* Нормализация (стили класса вернут нужный цвет) */
    filter: brightness(1);
    transform: skew(0deg) scale(1);
  }
}

/* --- НОВЫЕ KEYFRAMES --- */

/* 1. Глитч смерти: Хаотичный, рваный, "сломанный" */
@keyframes sn-death-glitch {
  0% {
    opacity: 1;
    transform: translate(0, 0) skew(0deg);
    filter: brightness(1) hue-rotate(0deg);
  }
  20% {
    opacity: 0.8;
    transform: translate(-2px, 2px) skew(10deg);
  }
  40% {
    opacity: 1;
    transform: translate(2px, -2px) skew(-10deg);
    /* Инверсия цвета или вспышка */
    filter: brightness(2) hue-rotate(-45deg);
  }
  60% {
    transform: translate(0, 0) scale(0.95);
  }
  80% {
    opacity: 0.6;
    transform: translate(1px, 1px) skew(5deg);
    background-color: #fff !important; /* Мерцание белым шумом */
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

/* 2. Глитч буста: Очень быстрый, едва заметный сдвиг (вибрация энергии) */
@keyframes sn-boost-glitch {
  0% { transform: translate(0, 0); opacity: 1; }
  25% { transform: translate(0.5px, 0.5px); opacity: 0.9; }
  50% { transform: translate(-0.5px, 0); opacity: 1; }
  75% { transform: translate(0, -0.5px); opacity: 0.95; }
  100% { transform: translate(0, 0); opacity: 1; }
}

/* Стили досье (переиспользуем из Garage/Tetris, но с нюансами) */
/* Эти классы должны быть глобальными или импортированными */`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/snake/Snake.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ,EAAE,SAAS;EACnB,gCAAgC;EAChC,WAAW;EACX,aAAa,gBAAgB,6BAA6B;EAC1D,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;;EAEjB,wDAAwD;EACxD,yBAAyB;;EAEzB,sBAAsB;EACtB,mBAAmB;EACnB;;;+BAG6B;;EAE7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;;IAEf,uDAAuD;IACvD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,cAAc;AACd;EACE,WAAW;;EAEX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB,cAAc,EAAE,4CAA4C,EAAE;;AAEnF,iBAAiB;AACjB;EACE;+CAC6C;EAC7C,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe,EAAE,iBAAiB;;EAElC,yBAAyB;EACzB,cAAc,KAAK,kCAAkC;EACrD,gBAAgB,GAAG,0DAA0D;AAC/E;;AAEA,gBAAgB;AAChB;EACE,yBAAyB,EAAE,+BAA+B;EAC1D,2BAA2B,EAAE,oBAAoB;;EAEjD,uEAAuE;EACvE,+BAA+B;EAC/B,6CAA6C;;EAE7C,kBAAkB;EAClB,YAAY,EAAE,mBAAmB;EACjC,UAAU;EACV,4EAA4E;AAC9E;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY,EAAE,mBAAmB;EACjC,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,yEAAyE;EACzE,UAAU;EACV,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,0EAA0E;EAC1E,UAAU;EACV,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA,yBAAyB;;AAEzB,gCAAgC;AAChC;EACE,oCAAoC,EAAE,kBAAkB;EACxD,uCAAuC;EACvC,sBAAsB;EACtB,yBAAyB;;EAEzB;8DAC4D;EAC5D,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,yEAAyE;AAC3E;;AAEA;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,8CAA8C,EAAE;EACtD,MAAM,4CAA4C,EAAE;EACpD,MAAM,2CAA2C,EAAE;EACnD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,4CAA4C,EAAE;EACpD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,OAAO,6CAA6C,EAAE;AACxD;;AAEA,qBAAqB;AACrB;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,4BAA4B,EAAE,qBAAqB;EACnD,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kDAAkD;EAClD,UAAU;EACV,YAAY,EAAE,uBAAuB;AACvC;;AAEA;EACE,OAAO,sBAAsB,EAAE,0CAA0C,EAAE;EAC3E,KAAK,qBAAqB,EAAE,yCAAyC,EAAE;AACzE;;AAEA;EACE,OAAO,qBAAqB,EAAE,YAAY,EAAE;EAC5C,KAAK,qBAAqB,EAAE,UAAU,EAAE;AAC1C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,cAAc;;EAEd,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,QAAQ;EACR,gBAAgB,EAAE,kBAAkB;;EAEpC,6BAA6B;EAC7B,gBAAgB,KAAK,4CAA4C;EACjE,mBAAmB,EAAE,oDAAoD;EACzE,iBAAiB;AACnB;;AAEA;;;;CAIC;AACD;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,gDAAgD;AAChD;EACE,2CAA2C;EAC3C,wDAAwD;EACxD,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,2BAA2B;EAC5C,yBAAiB;UAAjB,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB,gBAAgB;AAChB,YAAY,cAAc,EAAE,WAAW,EAAE;AACzC,YAAY,cAAc,EAAE,WAAW,EAAE,EAAE,kBAAkB;;AAE7D,eAAe;AACf,YAAY,cAAc,EAAE,WAAW,EAAE;AACzC,YAAY,cAAc,EAAE,WAAW,EAAE;AACzC,YAAY,cAAc,EAAE,WAAW,EAAE;;AAEzC,6BAA6B;AAC7B;EACE,wDAAwD;EACxD,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,WAAW;EACtC,iCAAiC;EACjC,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mDAAmD;EACnD,gCAAgC;AAClC;;AAEA;EACE,WAAW,qBAAqB,EAAE,UAAU,EAAE;EAC9C,MAAM,sBAAsB,EAAE,YAAY,EAAE;EAC5C,MAAM,qBAAqB,EAAE,UAAU,EAAE;EACzC,MAAM,eAAe,EAAE;AACzB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB,EAAE,sBAAsB;AAC/C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,KAAK,0CAA0C,EAAE;EACjD,MAAM,0CAA0C,EAAE;EAClD,OAAO,0CAA0C,EAAE;AACrD;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE;IACE,qBAAqB;IACrB,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;IACxC,cAAc;IACd,mDAAmD;IACnD,WAAW;EACb;EACA;IACE,yCAAyC;IACzC,sBAAsB;IACtB,gBAAgB;IAChB,iDAAiD;EACnD;EACA;IACE,mDAAmD;IACnD,qBAAqB;IACrB,8BAA8B;EAChC;AACF;;AAEA,4BAA4B;;AAE5B,oDAAoD;AACpD;EACE;IACE,UAAU;IACV,qCAAqC;IACrC,sCAAsC;EACxC;EACA;IACE,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,4CAA4C;IAC5C,+BAA+B;IAC/B,wCAAwC;EAC1C;EACA;IACE,sCAAsC;EACxC;EACA;IACE,YAAY;IACZ,yCAAyC;IACzC,iCAAiC,EAAE,yBAAyB;EAC9D;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA,0EAA0E;AAC1E;EACE,KAAK,0BAA0B,EAAE,UAAU,EAAE;EAC7C,MAAM,kCAAkC,EAAE,YAAY,EAAE;EACxD,MAAM,+BAA+B,EAAE,UAAU,EAAE;EACnD,MAAM,+BAA+B,EAAE,aAAa,EAAE;EACtD,OAAO,0BAA0B,EAAE,UAAU,EAAE;AACjD;;AAEA,iEAAiE;AACjE,4DAA4D","sourcesContent":["/* games/snake/Snake.css */\n\n.snake-container {\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 50%; left: 50%;\n  transform: translate(-50%, -50%);\n  width: 96vw;\n  min-height: 0;               /* важно для вложенных flex */\n  max-width: 400px;\n  height: calc(100% - 20px);\n  max-height: 900px;\n\n  /* Фон теперь почти черный, матрица будет canvas-слоем */\n  background-color: #050505;\n\n  border: 4px solid #333;\n  border-radius: 16px;\n  box-shadow:\n    0 0 0 1px #000,\n    inset 0 0 40px rgba(0, 0, 0, 0.8),\n    0 20px 60px rgba(0,0,0,0.9);\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 5px;\n  box-sizing: border-box;\n  font-family: 'Courier New', monospace;\n  color: #00ff41;\n  z-index: 6000;\n  user-select: none;\n\n    /* Блокируем стандартные жесты браузера (скролл, зум) */\n    touch-action: none;\n    overflow: hidden;\n}\n\n/* ЗАГОЛОВОК */\n.snake-header {\n  width: 100%;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  background: #161b22;\n  border: 1px solid #30363d;\n  border-radius: 6px;\n  box-shadow: 0 4px 0 rgba(0,0,0,0.2);\n  box-sizing: border-box;\n}\n\n.snake-stat-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.snake-label {\n  font-size: 10px;\n  color: #8b949e;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.snake-value {\n  font-size: 18px;\n  font-weight: 900;\n  color: #f0f6fc;\n}\n\n.snake-value.score { color: #fbbf24; text-shadow: 0 0 5px rgba(251, 191, 36, 0.3); }\n\n/* ИГРОВОЕ ПОЛЕ */\n.snake-grid {\n  /* Фон стал немного прозрачнее (0.4), чтобы матрицу было видно лучше,\n     но достаточно темным, чтобы был контраст */\n  background: rgba(0, 0, 0, 0.4);\n  border: 2px solid #30363d;\n  border-radius: 4px;\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  display: grid;\n  box-shadow: inset 0 0 20px rgba(0, 0, 0, 1);\n  overflow: hidden;\n}\n\n/* ЯЧЕЙКИ */\n.sn-cell {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 14px; /* Размер буквы */\n\n  /* ДОБАВИТЬ ЭТИ СТРОКИ: */\n  line-height: 1;    /* Убирает лишние отступы шрифта */\n  overflow: hidden;  /* Обрезает контент, не давая ему влиять на размер сетки */\n}\n\n/* ЗМЕЯ (ТЕЛО) */\n.sn-snake-body {\n  background-color: #238636; /* Вернули насыщенный зеленый */\n  box-shadow: 0 0 4px #2ea043; /* Мягкое свечение */\n\n  /* Текст: полупрозрачный и с размытой тенью для эффекта \"внутри геля\" */\n  color: rgba(255, 255, 255, 0.5);\n  text-shadow: 0 0 4px rgba(255, 255, 255, 0.4);\n\n  border-radius: 2px;\n  border: none; /* Убрали обводку */\n  z-index: 2;\n  /* ИСПРАВЛЕНИЕ 1: Убрали общий transition, чтобы не мелькало при появлении */\n}\n\n/* ЗМЕЯ (ГОЛОВА) */\n.sn-snake-head {\n  background-color: #3fb950;\n  box-shadow: 0 0 12px #3fb950;\n  color: #fff;\n  z-index: 3;\n  border-radius: 2px;\n  border: none; /* Убрали обводку */\n  /* ИСПРАВЛЕНИЕ 1: Убрали общий transition */\n}\n\n/* --- ЭФФЕКТ УСКОРЕНИЯ (BOOST) --- */\n.sn-snake-body.boosting {\n  background-color: #3fcd50 !important;\n  box-shadow: 0 0 6px #45e948, 0 0 10px rgba(255, 255, 255, 0.5) !important;\n  z-index: 4;\n  /* НОВОЕ: Едва заметная вибрация */\n  animation: sn-boost-glitch 0.1s infinite;\n}\n\n.sn-snake-head.boosting {\n  background-color: #ebeb7f !important;\n  box-shadow: 0 0 10px #fbff90, 0 0 10px rgba(255, 255, 255, 0.8) !important;\n  z-index: 5;\n  /* НОВОЕ: Едва заметная вибрация */\n  animation: sn-boost-glitch 0.1s infinite;\n}\n\n/* --- СТИЛИ СМЕРТИ --- */\n\n/* Вся змея становится красной */\n.sn-snake-body.dead, .sn-snake-head.dead {\n  background-color: #dc2626 !important; /* Яркий красный */\n  box-shadow: 0 0 10px #ef4444 !important;\n  color: #fff !important;\n  border: 1px solid #7f1d1d;\n\n  /* НОВОЕ: Анимация глитча смерти будет задаваться через JS\n     или CSS класс, но базовые переходы убираем для резкости */\n  transition: none;\n}\n\n/* Тряска сетки при смерти */\n.snake-grid.shaking {\n  animation: sn-shake-hard 0.5s cubic-bezier(.36,.07,.19,.97) both infinite;\n}\n\n@keyframes sn-shake-hard {\n  0% { transform: translate(1px, 1px) rotate(0deg); }\n  10% { transform: translate(-1px, -2px) rotate(-1deg); }\n  20% { transform: translate(-3px, 0px) rotate(1deg); }\n  30% { transform: translate(3px, 2px) rotate(0deg); }\n  40% { transform: translate(1px, -1px) rotate(1deg); }\n  50% { transform: translate(-1px, 2px) rotate(-1deg); }\n  60% { transform: translate(-3px, 1px) rotate(0deg); }\n  70% { transform: translate(3px, 1px) rotate(-1deg); }\n  80% { transform: translate(-1px, -1px) rotate(1deg); }\n  90% { transform: translate(1px, 2px) rotate(0deg); }\n  100% { transform: translate(1px, -2px) rotate(-1deg); }\n}\n\n/* ЕДА (КВАДРАТНАЯ) */\n.sn-food {\n  background-color: #da3633; /* Матовый красный */\n  box-shadow: 0 0 10px #da3633; /* Красное свечение */\n  color: #fff;\n  font-size: 12px;\n  border-radius: 2px;\n  animation: sn-pulse-square 0.8s infinite alternate;\n  z-index: 2;\n  border: none; /* Убрали белую рамку */\n}\n\n@keyframes sn-pulse-square {\n  from { transform: scale(0.85); box-shadow: 0 0 5px rgba(220, 38, 38, 0.5); }\n  to { transform: scale(1.0); box-shadow: 0 0 15px rgba(220, 38, 38, 1); }\n}\n\n@keyframes sn-pulse {\n  from { transform: scale(0.8); opacity: 0.8; }\n  to { transform: scale(1.0); opacity: 1; }\n}\n\n/* ОВЕРЛЕЙ ПАУЗЫ */\n.snake-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(13, 17, 23, 0.85);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  backdrop-filter: blur(2px);\n}\n\n.snake-paused-text {\n  font-size: 24px;\n  font-weight: 900;\n  color: #fff;\n  border: 2px solid #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  transform: rotate(-3deg);\n  background: rgba(0,0,0,0.5);\n  box-shadow: 0 0 15px rgba(255,255,255,0.2);\n}\n\n/* --- УПРАВЛЕНИЕ (ОБНОВЛЕНО: ЛОГИКА ПОЗИЦИОНИРОВАНИЯ) --- */\n.snake-controls-wrapper {\n  width: 100%;\n  flex-shrink: 0;\n\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: 50px 50px;\n  gap: 8px;\n  max-width: 300px; /* Центрирование */\n\n  /* ЛОГИКА \"ПРИЖАТЬ К НИЗУ\": */\n  margin-top: auto;    /* Толкает блок в самый низ свободной зоны */\n  margin-bottom: 20px; /* Фиксированный отступ от дна (когда места много) */\n  padding-bottom: 0;\n}\n\n/* ЛОГИКА \"ЦЕНТРИРОВАТЬ, КОГДА ТЕСНО\":\n   Если высота экрана меньше 700px (например, старые айфоны или ландшафт),\n   мы возвращаем margin-bottom: auto.\n   В сочетании с margin-top: auto это центрирует блок в свободном пространстве.\n*/\n@media (max-height: 650px) {\n  .snake-controls-wrapper {\n    margin-bottom: auto;\n  }\n}\n\n/* Общий стиль для всех кнопок (включая паузу) */\n.sn-btn, .sn-pause-btn {\n  /* Стиль тетриса: градиент, границы, тень */\n  background: linear-gradient(to bottom, #34495e, #2c3e50);\n  border: 1px solid #1a252f;\n  border-top: 1px solid #4e6075;\n  border-radius: 6px;\n  color: #ecf0f1;\n  font-size: 18px;\n  display: flex; align-items: center; justify-content: center;\n  cursor: pointer; box-shadow: 0 3px 0 #151f28;\n  user-select: none; touch-action: manipulation;\n}\n\n.sn-pause-btn {\n  margin: 0 0 15px 15px;\n}\n\n.sn-btn:active, .sn-pause-btn:active {\n  transform: translateY(2px);\n  box-shadow: 0 1px 0 #151f28;\n  background: #2c3e50;\n}\n\n/* Раскладка кнопок */\n/* Верхний ряд */\n.sn-up    { grid-column: 2; grid-row: 1; }\n.sn-pause { grid-column: 3; grid-row: 1; } /* Справа сверху */\n\n/* Нижний ряд */\n.sn-left  { grid-column: 1; grid-row: 2; }\n.sn-down  { grid-column: 2; grid-row: 2; }\n.sn-right { grid-column: 3; grid-row: 2; }\n\n/* Зеленая кнопка при паузе */\n.sn-pause-btn.paused {\n  background: linear-gradient(to bottom, #27ae60, #1e8449);\n  border-color: #1e8449;\n  box-shadow: 0 3px 0 #145a32;\n  color: #fff;\n}\n.sn-pause-btn.paused:active {\n  box-shadow: 0 1px 0 #145a32;\n}\n\n/* --- СТАРТОВЫЙ ЭКРАН (ТЕРМИНАЛ) --- */\n.sn-start-card {\n  width: 100%;\n  max-width: 340px;\n  background: rgba(5, 10, 5, 0.95);\n  border: 1px solid #00ff41;\n  padding: 30px 20px;\n  border-radius: 4px;\n  box-shadow: 0 0 20px rgba(0, 255, 65, 0.2);\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Линия сканирования */\n.sn-start-card::after {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0; height: 5px;\n  background: rgba(0, 255, 65, 0.3);\n  opacity: 0.5;\n  animation: sn-scanline 3s linear infinite;\n}\n\n@keyframes sn-scanline {\n  0% { transform: translateY(-100%); }\n  100% { transform: translateY(500px); }\n}\n\n.sn-start-icon {\n  font-size: 60px;\n  color: #00ff41;\n  margin-bottom: 20px;\n  filter: drop-shadow(0 0 10px rgba(0, 255, 65, 0.5));\n  animation: sn-glitch 2s infinite;\n}\n\n@keyframes sn-glitch {\n  0%, 100% { transform: skew(0deg); opacity: 1; }\n  10% { transform: skew(-5deg); opacity: 0.8; }\n  20% { transform: skew(5deg); opacity: 1; }\n  80% { transform: none; }\n}\n\n.sn-start-title {\n  font-family: 'Courier New', monospace;\n  font-size: 20px;\n  font-weight: 900;\n  color: #00ff41;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #333;\n  padding-bottom: 10px;\n}\n\n.sn-start-desc {\n  font-family: 'Courier New', monospace;\n  font-size: 14px;\n  color: #a3b3a3;\n  line-height: 1.5;\n  margin-bottom: 30px;\n  white-space: pre-line; /* Чтобы работали \\n */\n}\n\n.sn-start-btn {\n  background: #00ff41;\n  color: #000;\n  font-family: 'Courier New', monospace;\n  font-weight: 900;\n  font-size: 18px;\n  border: none;\n  padding: 15px 0;\n  width: 100%;\n  cursor: pointer;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  box-shadow: 0 0 10px rgba(0, 255, 65, 0.4);\n  transition: all 0.2s;\n  animation: sn-pulse-btn 1.5s infinite;\n}\n\n@keyframes sn-pulse-btn {\n  0% { box-shadow: 0 0 10px rgba(0, 255, 65, 0.4); }\n  50% { box-shadow: 0 0 25px rgba(0, 255, 65, 0.8); }\n  100% { box-shadow: 0 0 10px rgba(0, 255, 65, 0.4); }\n}\n\n.sn-start-btn:active {\n  background: #fff;\n  transform: scale(0.98);\n}\n\n/* --- АНИМАЦИЯ ГЛИТЧА ПРИ ПОЕДАНИИ --- */\n@keyframes sn-eat-glitch {\n  0% {\n    filter: brightness(1);\n    transform: skew(0deg) scale(1);\n  }\n  20% {\n    /* Вспышка белым */\n    background-color: #fff;\n    box-shadow: 0 0 15px #fff, 0 0 30px #0f0;\n    /* Искажение */\n    transform: skew(-20deg) scale(1.1) translateX(-2px);\n    z-index: 10;\n  }\n  40% {\n    /* Инверсия или затемнение на мгновение */\n    background-color: #000;\n    box-shadow: none;\n    transform: skew(20deg) scale(0.9) translateX(2px);\n  }\n  60% {\n    /* Нормализация (стили класса вернут нужный цвет) */\n    filter: brightness(1);\n    transform: skew(0deg) scale(1);\n  }\n}\n\n/* --- НОВЫЕ KEYFRAMES --- */\n\n/* 1. Глитч смерти: Хаотичный, рваный, \"сломанный\" */\n@keyframes sn-death-glitch {\n  0% {\n    opacity: 1;\n    transform: translate(0, 0) skew(0deg);\n    filter: brightness(1) hue-rotate(0deg);\n  }\n  20% {\n    opacity: 0.8;\n    transform: translate(-2px, 2px) skew(10deg);\n  }\n  40% {\n    opacity: 1;\n    transform: translate(2px, -2px) skew(-10deg);\n    /* Инверсия цвета или вспышка */\n    filter: brightness(2) hue-rotate(-45deg);\n  }\n  60% {\n    transform: translate(0, 0) scale(0.95);\n  }\n  80% {\n    opacity: 0.6;\n    transform: translate(1px, 1px) skew(5deg);\n    background-color: #fff !important; /* Мерцание белым шумом */\n  }\n  100% {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n}\n\n/* 2. Глитч буста: Очень быстрый, едва заметный сдвиг (вибрация энергии) */\n@keyframes sn-boost-glitch {\n  0% { transform: translate(0, 0); opacity: 1; }\n  25% { transform: translate(0.5px, 0.5px); opacity: 0.9; }\n  50% { transform: translate(-0.5px, 0); opacity: 1; }\n  75% { transform: translate(0, -0.5px); opacity: 0.95; }\n  100% { transform: translate(0, 0); opacity: 1; }\n}\n\n/* Стили досье (переиспользуем из Garage/Tetris, но с нюансами) */\n/* Эти классы должны быть глобальными или импортированными */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
